import(/* webpackMode: "eager" */ "/vercel/path0/src/components/category-list.tsx")